/* eslint-disable import/prefer-default-export */

import { Placement } from '@floating-ui/react'
import { FC, MouseEvent, useCallback, useMemo } from 'react'

import styles from './AssetTypeSelectV2.module.scss'

import { useOrganizationAssetTypeOptions } from '~entities/assets/model'
import { AssetTypes } from '~generated/types'
import Dropdown, { DropdownMenu, useDropdownMenu } from '~shared/ui/Dropdown'
import Flex from '~shared/ui/Flex'
import Text from '~shared/ui/Text'

interface AssetTypeSelectProps {
  value: AssetTypes
  onChange: (value: AssetTypes) => void
  placeholder?: string
  placement?: Placement
}

export const AssetTypeSelectV2: FC<AssetTypeSelectProps> = ({ value, onChange, placeholder = 'Select', placement }) => {
  const { refs, getMenuProps, getReferenceProps } = useDropdownMenu({
    placement,
    offset: 4,
  })

  const typeOptions = useOrganizationAssetTypeOptions()

  const selectedOption = useMemo(() => typeOptions?.find((option) => option?.value === value), [typeOptions, value])

  const handleClick = useCallback(
    (ev: MouseEvent<HTMLElement>) => {
      ev.stopPropagation()
      onChange?.(ev.currentTarget.dataset.value as AssetTypes)
    },
    [onChange]
  )

  return (
    <div>
      <button ref={refs.setReference} {...getReferenceProps()} className={styles.root}>
        <Flex align="center" justify="center" colGap="1">
          {selectedOption?.getIcon() || null}
          <Text textType="caption">{selectedOption?.label || placeholder}</Text>
        </Flex>
      </button>

      <DropdownMenu ref={refs.setFloating} {...getMenuProps()}>
        <Dropdown.List>
          {typeOptions.map((option) => (
            <Dropdown.Item
              key={option.value}
              data-value={option.value as string}
              before={option.getIcon()}
              onClick={handleClick}
            >
              {option.label}
            </Dropdown.Item>
          ))}
        </Dropdown.List>
      </DropdownMenu>
    </div>
  )
}
